// Angular
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FilterOption } from '../filters/filters.component';

@Component({
	selector: 'filters-view',
	templateUrl: './filters-view.component.html',
	styleUrls: ['./filters-view.component.scss'],
})
export class FiltersViewComponent implements OnInit {
  @Input() selectedFilters: FilterOption[] = [];
  @Output() removed: EventEmitter<FilterOption> = new EventEmitter();

  constructor() { }

  ngOnInit() { }
  
  removeFilter(filter: FilterOption) {
    this.selectedFilters.splice(this.selectedFilters.indexOf(filter), 1);
    this.removed.emit(filter);
  }

  getType(type: string) {
    switch (type) {
      case 'Equal': return '=';
      case 'GreaterThan': return '>';
      case 'GreaterThanOrEqual': return '>=';
      case 'LessThan': return '<';
      case 'LessThanOrEqual': return '<=';
      case 'StringEqual': return ' = ';
      default: return type;
    }
  }

  get displayFilters() {
      return this.selectedFilters.filter(filter => !filter.nonDisplayFilter)
  }
}
